import { Link } from "react-router-dom";
import type { Article } from "@/mocks/articles";

function formatCount(n: number) {
  if (n >= 10000) return `${(n / 10000).toFixed(1)}万`;
  return n.toLocaleString("zh-CN");
}

export default function ArticleCard({ article, big = false }: { article: Article; big?: boolean }) {
  return (
    <article className="group flex h-full flex-col overflow-hidden rounded-xl border border-background-200/70 bg-background-50 transition-all duration-300 hover:-translate-y-1 hover:border-primary-200 hover:shadow-soft">
      <Link to={`/article/${article.slug}`} className="relative block w-full overflow-hidden" aria-label={article.title}>
        <div className={`w-full ${big ? "aspect-[4/3]" : "aspect-[4/3]"}`}>
          <img
            src={article.cover}
            alt={`${article.title} 封面配图`}
            title={`${article.title} · 师兄啊师兄剧情解析`}
            className="h-full w-full object-cover transition-transform duration-500 group-hover:scale-105"
          />
        </div>
        <span className="absolute left-3 top-3 rounded-full bg-background-50/90 px-3 py-1 text-xs font-medium text-primary-700 backdrop-blur">
          {article.categoryName}
        </span>
      </Link>

      <div className="flex flex-1 flex-col p-4 md:p-5">
        <h3 className={`font-heading font-semibold leading-snug text-foreground-950 ${big ? "text-lg" : "text-base"}`}>
          <Link to={`/article/${article.slug}`} className="transition-colors hover:text-primary-700">
            {article.title}
          </Link>
        </h3>
        <p className="mt-2 line-clamp-2 text-sm leading-relaxed text-foreground-500">{article.excerpt}</p>

        <div className="mt-4 flex flex-wrap items-center gap-x-4 gap-y-1 border-t border-background-200/80 pt-3 text-xs text-foreground-400">
          <span className="flex items-center gap-1 whitespace-nowrap">
            <i className="ri-user-3-line text-sm"></i>
            {article.author}
          </span>
          <span className="flex items-center gap-1 whitespace-nowrap">
            <i className="ri-calendar-line text-sm"></i>
            {article.date}
          </span>
          <span className="flex items-center gap-1 whitespace-nowrap">
            <i className="ri-eye-line text-sm"></i>
            {formatCount(article.reads)}
          </span>
          <span className="flex items-center gap-1 whitespace-nowrap">
            <i className="ri-chat-1-line text-sm"></i>
            {formatCount(article.comments)}
          </span>
        </div>
      </div>
    </article>
  );
}